import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { cacheActionCreators } from '../../stores/lis-clear-cache-store';
import { navActionCreators } from '../../stores/lis-nav-store';

class ClearCacheComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceOptions: [
                { label: "AdvancedLegislationSearch", value: "AdvancedLegislationSearch" },
                { label: "Authentication", value: "Authentication" },
                { label: "Calendar", value: "Calendar" },
                { label: "CalendarFileGeneration", value: "CalendarFileGeneration" },
                { label: "Committee", value: "Committee" },
                { label: "CommitteeLegislationReferral", value: "CommitteeLegislationReferral" },
                { label: "CommunicationFileGeneration", value: "CommunicationFileGeneration" },
                { label: "Contact", value: "Contact" },
                { label: "Groups", value: "Groups" },
                { label: "GroupsRoles", value: "GroupsRoles" },
                { label: "JournalFileGeneration", value: "JournalFileGeneration" },
                { label: "Legislation", value: "Legislation" },
                { label: "LegislationByMember", value: "LegislationByMember" },
                { label: "LegislationCollections", value: "LegislationCollections" },
                { label: "LegislationCommunications", value: "LegislationCommunications" },
                { label: "LegislationEvent", value: "LegislationEvent" },
                { label: "LegislationFileGeneration", value: "LegislationFileGeneration" },
                { label: "LegislationPatron", value: "LegislationPatron" },
                { label: "LegislationSubject", value: "LegislationSubject" },
                { label: "LegislationSummary", value: "LegislationSummary" },
                { label: "LegislationText", value: "LegislationText" },
                { label: "LegislationVersion", value: "LegislationVersion" },
                { label: "Member", value: "Member" },
                { label: "MembersByCommittee", value: "MembersByCommittee" },
                { label: "MemberSearch", value: "MemberSearch" },
                { label: "MemberVoteSearch", value: "MemberVoteSearch" },
                { label: "MinutesEntries", value: "MinutesEntries" },
                { label: "MinutesBook", value: "MinutesBook" },
                { label: "Notification", value: "Notification" },
                { label: "Organization", value: "Organization" },
                { label: "PartnerAuthentication", value: "PartnerAuthentication" },
                { label: "Person", value: "Person" },
                { label: "Personnel", value: "Personnel" },
                { label: "PrintDocuments", value: "PrintDocuments" },
                { label: "Roles", value: "Roles" },
                { label: "Schedule", value: "Schedule" },
                { label: "Session", value: "Session" },
                { label: "Statistics", value: "Statistics" },
                { label: "Vote", value: "Vote" },
                { label: "VoteFileGeneration", value: "VoteFileGeneration" },
            ],
            selectedService: "",
            clearing: false
        };

        this.handleClearRequest = this.handleClearRequest.bind(this);
        this.handleServiceChange = this.handleServiceChange.bind(this);
    }

    handleClearRequest() {
        /* Add toast messages */
        try {
            this.setState({
                clearing: true
            }, () => {
                if (this.state.selectedService.value !== "Authentication") {
                    this.props.actions.clearPartnerCache(this.state.selectedService.value).then(() => {
                        this.props.actions.clearPublicCache(this.state.selectedService.value).then(() => {
                            this.setState({
                                clearing: false
                            })
                            this.props.actions.makeToast([{ type: "success", message: this.state.selectedService.label + " service cache cleared." }])
                        })
                    })
                } else {
                    this.props.actions.clearAuthCache().then(() => {
                        this.setState({
                            clearing: false
                        })
                        this.props.actions.makeToast([{ type: "success", message: this.state.selectedService.label + " service cache cleared." }])
                    })
                }
            })
        }
        catch (e) {
            this.setState({
                clearing: false
            }, () => {
                console.log(e)
                this.props.actions.makeToast([{ type: "error", message: "Cache clear failed" }])
            })
        }
    }

    handleServiceChange(value) {
        this.setState({
            selectedService: value
        })
    }

    render() {
        return (
            <div className='dlas-forms'>
                <h3>Clear Cache</h3>
                <label>Service</label>
                <div style={{ width: "50%", display: "grid", gridTemplateRows: "1fr 1fr", gridGap: "10px", marginTop: "10px" }}>
                    <Select
                        value={this.state.selectedService}
                        options={this.state.serviceOptions}
                        onChange={(value) => this.handleServiceChange(value)}
                        classNamePrefix='no-width-dropdown-input'
                    />
                    <button disabled={!this.state.selectedService.value || this.state.clearing} className='button primary' style={{ width: "100px" }} onClick={() => this.handleClearRequest()}>Clear</button>
                </div>
            </div>
        )
    }
}

const ClearCache = connect(
    (state) => {
        const { cache, nav } = state;
        return {
            cache,
            nav
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, cacheActionCreators, navActionCreators), dispatch)
        }
    }
)(ClearCacheComponent);

export default ClearCache;
